/**
 * Pushes one or more events to the GTM dataLayer.
 * Initializes the dataLayer array if it does not exist.
 *
 * @param events - The event objects to push to the dataLayer.
 */
export function pushToDataLayer(...events) {
    if (typeof window === 'undefined')
        return;
    window.dataLayer = window.dataLayer || [];
    for (const event of events) {
        window.dataLayer.push(event);
    }
}
/**
 * Clears the ecommerce object in the dataLayer.
 * Must be called before each enhanced ecommerce push to prevent data leakage between events.
 */
export function clearEcommerce() {
    pushToDataLayer({ ecommerce: null });
}
/**
 * Pushes an enhanced ecommerce event to the dataLayer.
 * Automatically clears the previous ecommerce object before pushing.
 *
 * @param event - The ecommerce event payload.
 */
export function pushEcommerceEvent(event) {
    clearEcommerce();
    pushToDataLayer(event);
}
/**
 * Pushes an async action event to the dataLayer.
 * Follows the spec pattern: clears custom_parameter first, then pushes the full event.
 *
 * @param eventName - The custom event name identifier.
 * @param params - Custom parameters for the event.
 * @param userFields - Optional hashed user identifiers and lifecycle fields.
 */
export function pushAsyncAction(eventName, params, userFields) {
    pushToDataLayer({ custom_parameter: null });
    const event = {
        event: 'async_action',
        custom_event_name: eventName,
        custom_parameter: params,
        ...userFields
    };
    pushToDataLayer(event);
}
